import { TableFilter, TableFilterType } from '@store/common/tableFilter.model';
import { TableConfig } from '@constants/table.constants';
import APIAxios, { APIRoutes } from '@api/axios.api';
import { catchError, from, map } from 'rxjs';
import { AxiosError, AxiosResponse } from 'axios';
import SnackError from '@utils/error.utils';
import { OrganisationStatus } from '@store/common/organisation.enums';

export enum FilterBaseEntityEnum {
  EXECUTION = 'EXECUTION',
  EXECUTION_LINE = 'EXECUTION_LINE',
  SERVICE = 'SERVICE',
  NONE = 'NONE'
}

export class FiltersService {

  getFilters = (searchEntity: TableFilterType, baseEntity: FilterBaseEntityEnum, existingFilters: TableFilter[], searchString?: string) => {

    const filteredTableFilters = existingFilters.filter((filter) => filter.type !== searchEntity);

    const params = {
      searchEntity,
      baseEntity,
      ...TableFilter.toRequestFilters(filteredTableFilters),
      searchString: searchString || undefined,
      page: 1,
      limit: TableConfig.pagination,
      status: OrganisationStatus.ACTIVE
    };

    return from(APIAxios({
      ...APIRoutes.GETFilters(),
      params,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<{ id: number; name: string }[]>) => {
          return response.data;
        })
      );
  };

}

export const filtersService = new FiltersService();
